import { render } from "./DFormRow.vue?vue&type=template&id=3a99e034&scoped=true"
import script from "./DFormRow.vue?vue&type=script&lang=js"
export * from "./DFormRow.vue?vue&type=script&lang=js"

import "./DFormRow.vue?vue&type=style&index=0&id=3a99e034&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a99e034"]])

export default __exports__